import { api } from './client';

// ============================================================================
// Types
// ============================================================================

export interface Notification {
  id: string;
  type: 'TRANSACTIONAL' | 'TRIGGER' | 'MARKETING' | 'PERSONAL';
  title: string | null;
  content: string;
  isRead: boolean;
  createdAt: string;
  metadata: Record<string, unknown> | null;
}

export interface UnreadCountResponse {
  count: number;
}

// ============================================================================
// API Functions
// ============================================================================

/**
 * Get all notifications for a user
 */
export async function getNotifications(
  userId: string,
  options?: { limit?: number; offset?: number }
): Promise<Notification[]> {
  const params = new URLSearchParams();
  params.append('userId', userId);
  if (options?.limit) params.append('limit', options.limit.toString());
  if (options?.offset) params.append('offset', options.offset.toString());

  return api.get<Notification[]>(`/notifications?${params.toString()}`);
}

/**
 * Get unread notifications count
 */
export async function getUnreadCount(userId: string): Promise<number> {
  const result = await api.get<UnreadCountResponse>(
    `/notifications/unread-count?userId=${userId}`
  );
  return result.count;
}

/**
 * Mark a single notification as read
 */
export async function markAsRead(notificationId: string): Promise<boolean> {
  const result = await api.post<{ success: boolean }>(
    `/notifications/${notificationId}/read`,
    {}
  );
  return result.success;
}

/**
 * Mark all notifications as read
 */
export async function markAllAsRead(userId: string): Promise<number> {
  const result = await api.post<{ markedCount: number }>(
    `/notifications/read-all?userId=${userId}`,
    {}
  );
  return result.markedCount;
}
